"use strict";

exports.__esModule = true;
exports.DeviceLagController = void 0;
var _react = _interopRequireWildcard(require("react"));
var _index = require("../../../API/RealtimeConnection/index");
var _Env = require("../../../Env");
var _dec, _class, _DeviceLagController;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var DeviceLagController = exports.DeviceLagController = (_dec = _Env.EnvContext.withContext, _dec(_class = (_DeviceLagController = /*#__PURE__*/function (_Component) {
  function DeviceLagController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      isLagging: false
    };
    _this.updateLagStatus = function (_ref) {
      var _this$props$env;
      var value = _ref.value;
      var lagThreshold = _this.props.lagThreshold ? _this.props.lagThreshold : (_this$props$env = _this.props.env) != null && _this$props$env.deviceLagThreshold ? _this.props.env.deviceLagThreshold : 60000;
      var isLagging = Math.abs(value) > lagThreshold;
      if (isLagging !== _this.state.isLagging) {
        _this.setState({
          isLagging: isLagging
        });
      }
    };
    return _this;
  }
  _inheritsLoose(DeviceLagController, _Component);
  var _proto = DeviceLagController.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      device = _this$props.device,
      children = _this$props.children;
    return /*#__PURE__*/_react["default"].createElement(_index.RealtimeDataSubscription, {
      params: ["deviceClock", {
        entity: {
          device: device.uuid,
          name: "lag"
        }
      }],
      onData: this.updateLagStatus
    }, function () {
      return children(_this2.state);
    });
  };
  return DeviceLagController;
}(_react.Component), _DeviceLagController.defaultProps = {
  env: undefined
}, _DeviceLagController)) || _class);